import { CircularProgress } from '@mui/material'
import { createTheme } from '@mui/material/styles'
import React, { createContext, useEffect, useState } from 'react'
import { theme as defaultTheme } from '../Theme'
import axios from 'axios'

export const ConfigContext = createContext({})

//------------------------------------------------------------------------------------------------
// AQUI VAN TODAS LAS IMAGENES CON NOMBRE DEFAULT REEMPLAZANDO demoImage.png
const defaultImages = {
  logoNavBar:
    'https://commercial-associates-multimedia.s3.amazonaws.com/$clientName/logoNavBar.png',
  logoPDF:
    'https://commercial-associates-multimedia.s3.amazonaws.com/$clientName/logo.png',
  footerPDF:
    'https://commercial-associates-multimedia.s3.amazonaws.com/$clientName/footerPDF.png',
}

const generateUrls = (clientName, images) => {
  return Object.keys(images).reduce((accumulator, currentImage) => {
    accumulator[currentImage] = images[currentImage].replaceAll(
      '$clientName',
      clientName
    )
    return accumulator
  }, {})
}
//------------------------------------------------------------------------------------------------
export const ConfigContextProvider = (props) => {
  const [theme, setTheme] = useState(null)
  const [texts, setTexts] = useState(null)
  const [imageUrls, setImageUrls] = useState(null)
  const [thirdParty, setThirdParty] = useState(null)
  const [withoutMemberValidation, setWithoutMemberValidation] = useState(false)
  const [withoutUserNameField, setWithoutUserNameField] = useState(false)
  const [clientName, setClientName] = useState(
    sessionStorage.getItem('clientName') || undefined
  )
  const [ops, isOPS] = useState(sessionStorage.getItem('ops') || 'false')
  const [isMemberKeyEmail, setIsMemberKeyEmail] = useState(false)
  const [memberValidationEndpoint, setMemberValidationEndpoint] =
    useState(undefined)

  const demoPayload = {
    theme: defaultTheme,
    texts: {
      website: 'https://www.cstflightservices.com',
      membersSectionTitle: 'CST Flight Services MEMBERS',
      membersSectionDescription:
        'CST Members receive special pricing. If you are a CST Member, capture the email address you use to log into the Members’ website.',
      membersSectionButton: 'VALIDATE MEMBER EMAIL',
    },
    clientName: 'clientName',
    thirdParty: false,
    withoutMemberValidation: false,
    withoutUserNameField: false,
    memberValidationEndpoint: undefined,
    isMemberKeyEmail: false,
  }

  const query = new URLSearchParams(window.location.search)

  React.useEffect(() => {
    const setClient = async (query) => {
      const queryClientName = query.get('clientName')
      const currentClient = await sessionStorage.getItem('clientName')
      if (!currentClient) {
        if (query && queryClientName) {
          await sessionStorage.setItem('clientName', queryClientName)
          setClientName(queryClientName)
          query.delete('clientName')
          if (window.location.href.includes('/boe')) {
            window.location.replace('/boe')
          }
          if (window.location.href.includes('/cof')) {
            window.location.replace('/cof')
          }
          if (window.location.href.includes('/mx')) {
            window.location.replace('/mx')
          }
          if (window.location.href.includes('/quotes')) {
            window.location.replace(`/quotes?${query.toString()}`)
          }
        } else {
          await sessionStorage.setItem('clientName', 'cst')
          setClientName('cst')
        }
      } else {
        if (query && queryClientName && queryClientName !== currentClient) {
          await sessionStorage.setItem('clientName', queryClientName)
          setClientName(queryClientName)
          query.delete('clientName')
          if (window.location.href.includes('/boe')) {
            window.location.replace('/boe')
          }
          if (window.location.href.includes('/cof')) {
            window.location.replace('/cof')
          }
          if (window.location.href.includes('/mx')) {
            window.location.replace('/mx')
          }
          if (window.location.href.includes('/quotes')) {
            window.location.replace(`/quotes?${query.toString()}`)
          }
        }
      }
    }
    setClient(query)
  }, [query])

  React.useEffect(() => {
    const setProtection = async (query) => {
      const opsAccess = query.get('ops')
      const currentProtection = await sessionStorage.getItem('ops')
      if (!currentProtection) {
        if (query && opsAccess) {
          await sessionStorage.setItem('ops', opsAccess)
          isOPS(opsAccess)
          if (window.location.href.includes('/boe')) {
            window.location.replace('/boe')
          }
          if (window.location.href.includes('/cof')) {
            window.location.replace('/cof')
          }
          if (window.location.href.includes('/mx')) {
            window.location.replace('/mx')
          }
          if (window.location.href.includes('/quotes')) {
            window.location.replace('/quotes')
          }
        } else {
          await sessionStorage.setItem('ops', 'cst')
          isOPS('false')
        }
      } else {
        if (query && opsAccess && opsAccess !== currentProtection) {
          await sessionStorage.setItem('ops', opsAccess)
          isOPS(opsAccess)
          if (window.location.href.includes('/boe')) {
            window.location.replace('/boe')
          }
          if (window.location.href.includes('/cof')) {
            window.location.replace('/cof')
          }
          if (window.location.href.includes('/mx')) {
            window.location.replace('/mx')
          }
          if (window.location.href.includes('/quotes')) {
            window.location.replace('/quotes')
          }
        }
      }
    }
    setProtection(query)
  }, [query])

  useEffect(() => {
    const callData = async () => {
      if (clientName && clientName !== 'undefined') {
        const { data } = await axios.get(
          `https://6fqhhp89df.execute-api.us-east-1.amazonaws.com/dev/${clientName}`
        )
        if (data.theme) {
          setTheme(createTheme(data.theme))
          // setTheme(createTheme(adaptV4Theme(data.theme)))
          setTexts(data.texts)
          setImageUrls(generateUrls(data.clientName, defaultImages))
          setThirdParty(data.thirdParty)
          setWithoutMemberValidation(data.withoutMemberValidation)
          setIsMemberKeyEmail(data.isMemberKeyEmail)
          setMemberValidationEndpoint(data.memberValidationEndpoint)
          setWithoutUserNameField(data.withoutUserNameField ?? false)
        } else {
          setTheme(createTheme(demoPayload.theme))
          setTexts(demoPayload.texts)
          setImageUrls(generateUrls(demoPayload.clientName, defaultImages))
          setThirdParty(demoPayload.thirdParty)
          setWithoutMemberValidation(demoPayload.withoutMemberValidation)
          setIsMemberKeyEmail(demoPayload.isMemberKeyEmail)
          setMemberValidationEndpoint(demoPayload.memberValidationEndpoint)
          setWithoutUserNameField(data.withoutUserNameField ?? false)
        }
      }
    }

    callData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientName])

  const validData = theme && texts && imageUrls && clientName

  const safeRender = () => {
    if (!validData) {
      return (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </div>
      )
    } else {
      return props.children
    }
  }

  return (
    <ConfigContext.Provider
      value={{
        theme,
        imageUrls,
        texts,
        thirdParty,
        withoutMemberValidation,
        clientName,
        isMemberKeyEmail,
        memberValidationEndpoint,
        ops: ops,
        withoutUserNameField,
      }}
    >
      {safeRender()}
    </ConfigContext.Provider>
  )
}
